<template>
    <div class="flex flex-col py-6 px-5 bg-surface-raised border border-border-strong rounded-lgr w-full h-full" :title="tooltip">
        <i v-if="icon" class="mb-5 bi text-base" :class="icon" aria-hidden="true"></i>
        <div class="body-small-semibold text-ink mb-1">{{ label }}</div>
        <SkeletonLoader v-if="isLoading" class="h-9 w-full rounded-lgr" />
        <div v-else class="title-section text-ink">{{ formattedValue }}</div>
    </div>
</template>

<script setup lang="ts">
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
import { formatNumber } from "~vue/utils/formatNumber";
import { computed } from "vue";

const {
    label = "",
    value = "",
    isLoading = false,
} = defineProps<{
    icon?: string;
    label?: string;
    value?: string | number;
    isLoading?: boolean;
    tooltip?: string;
}>();

const formattedValue = computed(() => {
    if (typeof value === "number") {
        return formatNumber(value);
    }

    const numberValue = Number.parseFloat(value);
    if (Number.isNaN(numberValue)) {
        return value || "--";
    }

    return formatNumber(numberValue);
});
</script>
